export const environment = {
  production: true,
  apiUrl: 'https://garantiportalapi-Staging.azurewebsites.net/api/',
  brandName: 'Garanti Portal',
  creditorBrandName: 'Borgenärsportalen',
  norgeBrandName: 'Lønnsgaranti Portal',
  norgeHostnames: [] as string[],
};
